module.exports = __webpack_public_path__ + "static/station-egor-744524e5d5240435e0ed3f3f1135ec5a.jpg";